import axios from "axios";
import { toast } from "react-toastify";
//https://api-real.priceworth.com:7443/api/
//https://localhost:7166/api/


const API = axios.create({
    baseURL: "https://api-real.priceworth.com:7443/api/",
    headers: {
        "Content-Type": 'application/json',
    },
});


// const API = axios.create({
//     baseURL: "https://localhost:7166/api/",
//     headers: {
//         "Content-Type": 'application/json',
//     },
// });


API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) config.headers.Authorization = `Bearer ${token}`;

        return config;

    },
    (error) => Promise.reject(error)
);

API.interceptors.response.use(
    response => response,
    error => {

        if (!error.response) {

            console.error("API Server is not running.");

            toast("API not Connected");

            return Promise.reject(error);
        }

        if (error.response.status === 401) {

            localStorage.removeItem("token");

            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default API;